import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noSummary: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noSummaryWithIssueType: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resizeSpotlightMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resizeSpotlightMessageIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	miniModalSpotlightMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	miniModalSpotlightActionMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	miniModalSpotlightHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noSummaryWithIssueTypeIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	miniModalSpotlightMessageGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noSummary: {
		id: 'issue-create.common.no-summary',
		defaultMessage: '(No summary)',
		description:
			'Title to be displayed for the issue create modal in the mini and minimized state when there the summary field is empty',
	},
	noSummaryWithIssueType: {
		id: 'issue-create.common.no-summary-with-issue-type',
		defaultMessage: `{issueType, select,
            Task {New task}
            Subtask {New subtask}
            Story {New story}
            Bug {New bug}
            Epic {New epic}
            Idea {New idea}
            Request {New request}
            other {{issueType}}
        }`,
		description:
			'Title to be displayed for the issue create modal in the mini and minimized state when there the summary field is empty',
	},
	resizeSpotlightMessage: {
		id: 'issue-create.common.resize-spotlight-message',
		defaultMessage: 'Resize or minimize your issue to pause editing and navigate around Jira.',
		description:
			'Spotlight message to be displayed on the top right corner of the GIC modal view to explain how to use different modal sizes',
	},
	resizeSpotlightMessageIssueTermRefresh: {
		id: 'issue-create.common.resize-spotlight-message-issue-term-refresh',
		defaultMessage: 'Resize or minimize your work item to pause editing and navigate around Jira.',
		description:
			'Spotlight message to be displayed on the top right corner of the GIC modal view to explain how to use different modal sizes',
	},
	miniModalSpotlightMessage: {
		id: 'issue-create.common.mini-modal-spotlight-message',
		defaultMessage:
			'Create work in context and navigate your project without losing progress using the new create experience.{br}Expand to see the full view, or minimize to revisit it later. ',
		description:
			'Spotlight message to be displayed on the left side of the GIC modal view to explain the mini window',
	},
	miniModalSpotlightActionMessage: {
		id: 'issue-create.common.mini-modal-spotlight-action-message',
		defaultMessage: 'Got it',
		description: 'Spotlight action message to dismiss the spotlight',
	},
	miniModalSpotlightHeading: {
		id: 'issue-create.common.mini-modal-spotlight-heading',
		defaultMessage: 'Multitasking made easy',
		description: 'Spotlight heading',
	},
	noSummaryWithIssueTypeIssueTermRefresh: {
		id: 'issue-create.common.no-summary-with-issue-type-issue-term-refresh',
		defaultMessage: `{issueType, select,
            Task {New task}
            Subtask {New subtask}
            Story {New story}
            Bug {New bug}
            Epic {New epic}
            Idea {New idea}
            Request {New request}
            other {{issueType}}
        }`,
		description:
			'Title to be displayed for the issue create modal in the mini and minimized state when there the summary field is empty',
	},
	miniModalSpotlightMessageGalaxia: {
		id: 'issue-create.common.mini-modal-spotlight-message-galaxia',
		defaultMessage:
			'Create work in context and navigate your space without losing progress using the new create experience.{br}Expand to see the full view, or minimize to revisit it later.',
		description:
			'Spotlight message to be displayed on the left side of the GIC modal view to explain the mini window',
	},
});
export default messages;
